import { Alert, AlertTitle, Box, Button, Grid } from '@mui/material';
import React from 'react';
import styles from '@/styles.module.scss';

type ErrorPopinProps = {
  title: string;
  message: React.ReactNode;
  handler: React.MouseEventHandler<HTMLButtonElement> | undefined;
  button: React.ReactNode;
};

const ErrorPopin = ({ title, message, handler, button }: ErrorPopinProps) => (
  <Box className={styles.centredOnScreenErrorPopin}>
    <Grid container spacing={0} sx={{
      justifyContent: "center"
    }}>
      <Grid
        size={{
          xs: 10,
          sm: 8,
          md: 6,
        }}
      >
        <Alert severity="error" variant="outlined">
          <AlertTitle>{title}</AlertTitle>
          {message}
        </Alert>
        <br />
        <br />
      </Grid>
    </Grid>
    <Button variant="contained" type="button" onClick={handler}>
      {button}
    </Button>
  </Box>
);

export default ErrorPopin;
